module.exports = __webpack_public_path__ + "img/etc-logo.75e6a697.png";